import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get as getCookie } from 'js-cookie';
import { updateItem } from 'ducks/cart';
import guestCartCookieName from 'helpers/guestCartCookieName';
import RecurringToggle from './RecurringToggle';

class RecurringToggleForm extends React.Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      id: PropTypes.integer,
      quantity: PropTypes.integer,
      recurring: PropTypes.boolean,
    }).isRequired,
    updateCartItem: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      recurring: props.cartItem.recurring,
    };
    this.onUpdateCartItem = this.onUpdateCartItem.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      recurring: newProps.cartItem.recurring,
    });
  }

  async onUpdateCartItem(recurring) {
    this.setState({ recurring });
    const cartId = getCookie(guestCartCookieName);
    await this.props.updateCartItem(cartId, {
      id: this.props.cartItem.id,
      recurring,
    });
  }

  render() {
    const { cartItem } = this.props;
    const { recurring } = this.state;

    if (cartItem.sellableType !== 'Product') return <div />;
    if (!cartItem.allowsRecurringPurchase) return <div />;
    return (
      <RecurringToggle
        recurring={recurring}
        onChange={() => this.onUpdateCartItem(!this.state.recurring)}
      />
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  updateCartItem: updateItem,
};
export default connect(mapStateToProps, mapDispatchToProps)(
  RecurringToggleForm,
);



// WEBPACK FOOTER //
// ./src/components/shared/CartDrawer/components/RecurringToggleForm.jsx